export const categories = [
  {
    slug: "qingchun",
    name: "清纯系",
    description: "清新自然、纯真动人的清纯美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20natural%20makeup%20in%20white%20dress%20standing%20in%20sunlit%20meadow%20with%20wildflowers%2C%20soft%20natural%20lighting%2C%20fresh%20and%20innocent%20atmosphere%2C%20dreamy%20bokeh%20background%2C%20editorial%20fashion%20photography%20style%20with%20warm%20golden%20hour%20tones%2C%20clean%20composition%2C%20elegant%20and%20refined%20aesthetic&width=800&height=600&seq=cat-qingchun&orientation=landscape",
    count: 128,
  },
  {
    slug: "qizhi",
    name: "气质系",
    description: "优雅知性、气质出众的高端美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20in%20sophisticated%20black%20evening%20gown%20posing%20in%20modern%20minimalist%20studio%20with%20soft%20dramatic%20lighting%2C%20classy%20and%20refined%20portrait%2C%20high%20fashion%20editorial%20style%2C%20clean%20neutral%20gray%20backdrop%2C%20professional%20photography%20with%20beautiful%20shadow%20play%2C%20luxurious%20and%20timeless%20aesthetic&width=800&height=600&seq=cat-qizhi&orientation=landscape",
    count: 96,
  },
  {
    slug: "shishang",
    name: "时尚系",
    description: "潮流前沿、个性张扬的时尚美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Fashionable%20young%20Asian%20woman%20in%20trendy%20streetwear%20outfit%20posing%20in%20urban%20cityscape%20with%20neon%20lights%20and%20modern%20architecture%2C%20cool%20and%20edgy%20vibe%2C%20fashion%20magazine%20editorial%20style%2C%20vibrant%20night%20scene%2C%20professional%20photography%20with%20cinematic%20color%20grading%2C%20bold%20and%20confident%20aesthetic&width=800&height=600&seq=cat-shishang&orientation=landscape",
    count: 87,
  },
  {
    slug: "xinggan",
    name: "性感系",
    description: "魅力四射、风情万种的性感美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20Asian%20woman%20in%20elegant%20red%20dress%20posing%20in%20luxurious%20hotel%20suite%20interior%20with%20warm%20ambient%20lighting%2C%20alluring%20and%20confident%20expression%2C%20sophisticated%20boudoir%20photography%20style%2C%20rich%20velvet%20textures%20and%20golden%20accents%2C%20magazine%20cover%20quality%2C%20refined%20and%20tasteful%20sensual%20aesthetic&width=800&height=600&seq=cat-xinggan&orientation=landscape",
    count: 74,
  },
  {
    slug: "gufeng",
    name: "古风系",
    description: "汉服雅韵、古典唯美的古风美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20in%20traditional%20Chinese%20hanfu%20dress%20with%20flowing%20silk%20fabric%20standing%20in%20ancient%20Chinese%20garden%20with%20cherry%20blossoms%20and%20bamboo%2C%20soft%20ethereal%20lighting%2C%20classical%20Chinese%20painting%20aesthetic%2C%20elegant%20and%20graceful%20pose%2C%20dreamy%20atmosphere%20with%20mist%20and%20petals%2C%20artistic%20fine%20art%20photography&width=800&height=600&seq=cat-gufeng&orientation=landscape",
    count: 63,
  },
  {
    slug: "rixi",
    name: "日系",
    description: "日系清新、治愈温暖的日式美女写真合集",
    image: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20in%20casual%20Japanese%20style%20outfit%20with%20soft%20smile%20standing%20on%20quiet%20Tokyo%20street%20with%20cherry%20blossom%20trees%2C%20warm%20natural%20sunlight%2C%20Japanese%20magazine%20photography%20style%2C%20soft%20pastel%20color%20palette%2C%20clean%20and%20minimal%20composition%2C%20healing%20and%20warm%20atmosphere&width=800&height=600&seq=cat-rixi&orientation=landscape",
    count: 55,
  },
];

export const articles = [
  {
    id: 1,
    title: "春日花海清纯写真｜少女与花的美好邂逅",
    slug: "spring-flower-pure-photoshoot",
    category: "qingchun",
    image: "https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20with%20long%20black%20hair%20in%20flowing%20white%20dress%20sitting%20among%20colorful%20wildflowers%20in%20sunlit%20spring%20meadow%2C%20soft%20golden%20hour%20backlight%2C%20dreamy%20romantic%20atmosphere%2C%20natural%20makeup%20and%20gentle%20smile%2C%20editorial%20fashion%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20and%20inviting%20palette%2C%20high%20quality%20fine%20art%20portrait&width=1200&height=800&seq=article-1&orientation=landscape",
    excerpt: "春天的花海中，一位清纯少女与盛开的鲜花共同谱写了一场唯美的视觉诗篇。柔和的光线透过花瓣洒落，映衬出少女纯净的笑容与自然的姿态。",
    content: "在这个春意盎然的季节，我们邀请了一位充满灵气的模特，在一片浪漫的花海中完成了一组令人心动的写真拍摄。\n\n清晨的第一缕阳光穿透薄雾，洒在盛开的油菜花田上。模特身着一袭白色长裙，赤脚漫步在花丛之间，仿佛从画中走出的仙子。摄影师巧妙地运用了逆光拍摄手法，让每一张照片都充满了梦幻般的光晕效果。\n\n整个拍摄过程持续了四个小时，从清晨到正午，光线不断变化，每一刻都呈现出不同的美感。模特自然流露的笑容与花海的浪漫氛围完美融合，呈现出一组清新脱俗的春日写真。\n\n这组作品不仅仅是对美的记录，更是对青春与自然和谐共处的诗意表达。每一帧都值得细细品味。",
    date: "2026-08-08",
    views: 12860,
    likes: 2341,
    tags: ["清纯", "花海", "春日", "写真"],
  },
  {
    id: 2,
    title: "都市精英气质大片｜职场女神的优雅格调",
    slug: "urban-elite-elegant-photoshoot",
    category: "qizhi",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Asian%20businesswoman%20in%20tailored%20cream%20blazer%20and%20silk%20blouse%20standing%20by%20floor%20to%20ceiling%20window%20in%20modern%20high%20rise%20office%20with%20city%20skyline%20view%2C%20confident%20poised%20expression%2C%20soft%20natural%20daylight%2C%20luxurious%20corporate%20portrait%20photography%2C%20clean%20minimalist%20composition%2C%20professional%20yet%20feminine%20aesthetic%2C%20high%20end%20magazine%20editorial%20quality&width=1200&height=800&seq=article-2&orientation=landscape",
    excerpt: "当优雅遇上力量，一位职场女性在现代都市的背景下展现出令人赞叹的气质与魅力。干练的着装搭配精致的妆容，诠释了当代都市丽人的风采。",
    content: "在这座不夜城的最高处，我们用镜头捕捉了一位都市精英女性的优雅瞬间。\n\n拍摄地点选在了城市中心的一栋摩天大楼顶层，落地窗外是壮丽的城市天际线。模特一身奶油白色西装套裙，简约而不失精致，干练中透着温柔。\n\n摄影师采用了大量自然光的拍摄方式，利用大窗户透进来的柔和光线，营造出高级感的画面氛围。每一个姿态、每一个眼神都经过精心设计，将职场女性的自信与优雅展现得淋漓尽致。\n\n这组作品旨在重新定义当代女性的多元魅力——她们既能在职场上独当一面，也能在镜头前展现最动人的一面。优雅，是她们最好的名片。",
    date: "2026-08-07",
    views: 9830,
    likes: 1892,
    tags: ["气质", "职场", "优雅", "都市"],
  },
  {
    id: 3,
    title: "街头潮流风尚｜时尚女孩的都市漫步",
    slug: "street-fashion-trendy-photoshoot",
    category: "shishang",
    image: "https://readdy.ai/api/search-image?query=Trendy%20young%20Asian%20woman%20in%20oversized%20denim%20jacket%20and%20stylish%20sunglasses%20walking%20through%20vibrant%20city%20street%20with%20colorful%20graffiti%20walls%20and%20neon%20signs%2C%20cool%20confident%20street%20style%20vibe%2C%20dynamic%20urban%20fashion%20photography%2C%20cinematic%20color%20grading%20with%20warm%20and%20cool%20contrast%2C%20editorial%20streetwear%20aesthetic%2C%20energetic%20and%20modern%20composition&width=1200&height=800&seq=article-3&orientation=landscape",
    excerpt: "在这座充满活力的城市街头，一位时尚女孩用她独特的穿搭风格和自信的步伐，诠释了什么是真正的街头时尚美学。",
    content: "城市的街头永远是最能展现时尚态度的舞台。这一次，我们跟随一位风格独特的时尚博主，在城市的各个角落完成了这组个性十足的街拍写真。\n\n从充满艺术气息的涂鸦墙到霓虹闪烁的商业街区，每一个场景都在诉说着不同的故事。模特的穿搭融合了当季最流行的元素——oversized牛仔外套搭配高腰阔腿裤，运动鞋与精致配饰的碰撞，展现出不拘一格的混搭美学。\n\n摄影师采用了快节奏的抓拍手法，捕捉模特行走、转身、回眸的每一个自然瞬间。画面中的色彩处理大胆而富有层次，冷暖色调的对比让每一张照片都充满了视觉冲击力。\n\n这组作品不仅仅是时尚的记录，更是对年轻一代自由表达自我、敢于打破规则的态度的致敬。",
    date: "2026-08-06",
    views: 15670,
    likes: 3125,
    tags: ["时尚", "街拍", "潮流", "个性"],
  },
  {
    id: 4,
    title: "夜幕下的魅惑光影｜性感女神的私密时刻",
    slug: "night-glamour-sensual-photoshoot",
    category: "xinggan",
    image: "https://readdy.ai/api/search-image?query=Glamorous%20Asian%20woman%20in%20elegant%20silk%20slip%20dress%20posing%20by%20large%20window%20in%20dimly%20lit%20luxurious%20bedroom%20with%20city%20night%20lights%20through%20sheer%20curtains%2C%20soft%20moody%20atmospheric%20lighting%2C%20tasteful%20boudoir%20photography%20style%2C%20rich%20warm%20golden%20accents%20and%20deep%20shadows%2C%20refined%20sensual%20elegance%2C%20magazine%20editorial%20quality%20with%20intimate%20ambiance&width=1200&height=800&seq=article-4&orientation=landscape",
    excerpt: "当夜幕降临，华灯初上，一场关于光影与魅力的视觉盛宴在豪华套房中悄然上演。性感，从来不是张扬，而是一种优雅的自信。",
    content: "夜幕低垂，城市的灯火在窗外交织成一幅流动的画卷。我们选择了一间拥有超大落地窗的豪华套房作为拍摄场地，让城市的夜景成为最美的背景板。\n\n模特身着一件真丝吊带裙，简约的剪裁勾勒出完美的身材曲线。摄影师巧妙运用了室内暖色灯光与窗外冷色夜景的对比，创造出极具电影感的画面氛围。每一寸光影的流转都在讲述着关于女性魅力的故事。\n\n拍摄过程中，我们没有刻意摆拍，而是让模特在房间中自然地活动——倚窗远眺、轻抚发丝、回眸一笑。这些不经意的瞬间反而捕捉到了最真实的美。\n\n性感不是刻意，而是一种发自内心的自信与从容。这组作品正是对这种理念的最佳诠释。",
    date: "2026-08-05",
    views: 18920,
    likes: 4156,
    tags: ["性感", "夜景", "私房", "光影"],
  },
  {
    id: 5,
    title: "古韵汉服美人图｜穿越千年的东方雅韵",
    slug: "ancient-hanfu-beauty-photoshoot",
    category: "gufeng",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20in%20exquisite%20traditional%20Chinese%20hanfu%20with%20intricate%20golden%20embroidery%20and%20flowing%20long%20sleeves%20standing%20in%20ancient%20temple%20courtyard%20with%20cherry%20blossom%20petals%20falling%2C%20soft%20ethereal%20morning%20light%20filtering%20through%20trees%2C%20classical%20Chinese%20ink%20painting%20aesthetic%2C%20elegant%20poised%20demeanor%2C%20dreamy%20atmospheric%20photography%2C%20timeless%20oriental%20beauty&width=1200&height=800&seq=article-5&orientation=landscape",
    excerpt: "一袭华美汉服，穿越千年时光，在古寺庭院中演绎东方女性的典雅与风韵。这将是一次关于传统文化与现代摄影艺术的完美邂逅。",
    content: "在远离城市喧嚣的深山古寺中，我们完成了一次穿越时空的拍摄旅程。\n\n模特身着一套精工刺绣的唐制汉服，金线绣制的牡丹在晨光下熠熠生辉。古寺的庭院中，百年银杏树投下斑驳的光影，樱花花瓣随风飘落，整个场景宛如一幅流动的古代仕女图。\n\n摄影师采用了中国画中「留白」的构图理念，让画面既有东方美学的空灵意境，又不失现代摄影的精致质感。每一个镜头都在诉说着千年文化的深厚底蕴。\n\n从晨光熹微到日上三竿，我们捕捉到了光影变幻中汉服之美的最动人瞬间。这不仅是一组写真，更是对中华传统文化的一次深情致敬。",
    date: "2026-08-04",
    views: 11230,
    likes: 2689,
    tags: ["古风", "汉服", "东方美", "古典"],
  },
  {
    id: 6,
    title: "日系治愈写真｜温暖冬日的糖果色女孩",
    slug: "japanese-healing-winter-photoshoot",
    category: "rixi",
    image: "https://readdy.ai/api/search-image?query=Cute%20young%20Asian%20woman%20in%20cozy%20pastel%20sweater%20and%20beret%20hat%20holding%20warm%20coffee%20cup%20sitting%20in%20charming%20Japanese%20style%20cafe%20with%20warm%20wooden%20interior%20and%20fairy%20lights%2C%20soft%20winter%20sunlight%20through%20window%2C%20healing%20and%20cozy%20atmosphere%2C%20Japanese%20magazine%20photography%20style%2C%20warm%20candy%20color%20palette%2C%20gentle%20and%20inviting%20mood&width=1200&height=800&seq=article-6&orientation=landscape",
    excerpt: "在寒冷的冬日午后，一位糖果色系穿搭的女孩在温暖的日式咖啡馆中，演绎了一组充满治愈感的日系写真。每一帧都像一杯热可可，温暖人心。",
    content: "冬日的阳光透过咖啡馆的玻璃窗，洒在原木色的桌面上，空气中弥漫着咖啡豆的香气。我们选择了一间隐藏在城市角落的日式咖啡馆作为这组写真的拍摄地。\n\n模特一身奶油色毛衣搭配格纹短裙，头戴贝雷帽，手捧冒着热气的拿铁，整个画面洋溢着浓浓的日杂风格。柔和的光线让每一个细节都显得温柔而细腻。\n\n摄影师大量使用了浅景深的拍摄手法，将焦点集中在模特的表情和动作上，背景虚化成一团温暖的光斑。这种日系摄影特有的处理方式，让画面充满了治愈感和故事性。\n\n这组作品就像冬日里的一抹暖阳，让人看了就忍不住嘴角上扬。在这个快节奏的时代，偶尔也需要这样一份简单纯粹的温暖。",
    date: "2026-08-03",
    views: 14350,
    likes: 3280,
    tags: ["日系", "治愈", "冬日", "温暖"],
  },
  {
    id: 7,
    title: "校园清新日记｜重返十八岁的青涩时光",
    slug: "campus-fresh-diary-photoshoot",
    category: "qingchun",
    image: "https://readdy.ai/api/search-image?query=Young%20Asian%20female%20student%20in%20white%20shirt%20and%20pleated%20skirt%20reading%20book%20under%20large%20tree%20on%20university%20campus%20lawn%2C%20soft%20dappled%20sunlight%20through%20leaves%2C%20fresh%20and%20innocent%20atmosphere%2C%20nostalgic%20youth%20photography%2C%20clean%20bright%20colors%2C%20natural%20unposed%20moment%2C%20Japanese%20campus%20drama%20aesthetic&width=1200&height=800&seq=article-7&orientation=landscape",
    excerpt: "阳光透过梧桐树叶的缝隙洒落在草坪上，一位身穿校服的少女静静阅读，时光仿佛倒流回到那段最纯真的校园岁月。",
    content: "校园里的梧桐树依旧枝繁叶茂，只是树下的人已经不再是当年的我们。这次拍摄，我们回到了大学校园，用镜头重新拾起那些散落在时光里的青春记忆。\n\n模特一身简洁的白衬衫搭配百褶裙，长发在微风中轻轻飘动。她坐在大树下翻看一本旧书，阳光透过树叶在她身上投下斑驳的光影。这一幕，像极了我们每个人记忆中的那个下午。\n\n摄影师没有过多的干预，只是在一旁静静地记录。模特自然的举手投足间流露出的那种青春特有的青涩与美好，是任何刻意摆拍都无法复制的。\n\n当我们翻看这些照片的时候，仿佛闻到了那年夏天的青草香。这组作品，献给所有怀念青春的你。",
    date: "2026-08-02",
    views: 9120,
    likes: 1765,
    tags: ["清纯", "校园", "青春", "回忆"],
  },
  {
    id: 8,
    title: "高定礼服盛宴｜红毯女神的气质巅峰",
    slug: "couture-gown-elegance-photoshoot",
    category: "qizhi",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20in%20stunning%20champagne%20gold%20evening%20gown%20with%20flowing%20train%20descending%20grand%20marble%20staircase%20in%20luxurious%20ballroom%20with%20crystal%20chandeliers%2C%20regal%20poised%20expression%2C%20dramatic%20spotlight%20effect%2C%20high%20fashion%20couture%20editorial%20photography%2C%20opulent%20and%20refined%20atmosphere%2C%20magazine%20cover%20quality%20portrait&width=1200&height=800&seq=article-8&orientation=landscape",
    excerpt: "水晶吊灯的光芒洒落在大理石阶梯上，一位身着香槟金高定礼服的优雅女神缓缓走来。这一刻，她就是全场的焦点。",
    content: "华丽的宴会厅中，水晶吊灯折射出璀璨的光芒。我们选择了一个具有古典巴洛克风格的豪华宴会厅作为拍摄场地，让每一帧画面都充满了奢华与优雅的气息。\n\n模特身着一件香槟金色的高级定制礼服，裙摆上镶嵌的珠片在灯光下闪烁着迷人的光泽。她缓缓走下大理石阶梯，每一个动作都散发着与生俱来的高贵气质。\n\n摄影师采用了电影级的布光方案，主灯、辅助灯和轮廓灯的精妙配合，让模特的每一个角度都完美无瑕。暗调的背景与明亮的主体形成强烈的视觉对比，营造出极具张力的画面效果。\n\n气质，从来不是刻意营造的，而是由内而外自然散发的光芒。这组作品，是对优雅女性之美最极致的赞颂。",
    date: "2026-08-01",
    views: 10890,
    likes: 2340,
    tags: ["气质", "礼服", "高贵", "优雅"],
  },
  {
    id: 9,
    title: "赛博朋克夜之城｜科技感时尚大片",
    slug: "cyberpunk-night-city-photoshoot",
    category: "shishang",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20young%20Asian%20woman%20in%20metallic%20silver%20outfit%20with%20LED%20accent%20accessories%20standing%20in%20cyberpunk%20cityscape%20with%20neon%20lights%20and%20holographic%20displays%2C%20rain%20soaked%20streets%20reflecting%20colorful%20lights%2C%20sci%20fi%20fashion%20editorial%20style%2C%20dramatic%20cinematic%20lighting%20with%20cyan%20and%20magenta%2C%20futuristic%20urban%20aesthetic%2C%20bold%20avant%20garde%20fashion%20photography&width=1200&height=800&seq=article-9&orientation=landscape",
    excerpt: "霓虹闪烁的未来都市中，一位身穿金属质感服装的未来感女孩，在雨夜的街头展现了一场极具视觉冲击力的赛博朋克时尚盛宴。",
    content: "当科技与时尚碰撞，会擦出怎样的火花？这组赛博朋克风格的时尚大片给出了答案。\n\n拍摄地点选在了城市中最具未来感的科技园区，霓虹灯牌、全息投影、金属建筑构成了一个仿佛来自未来的世界。模特一身银色金属质感套装搭配LED发光配饰，宛如从科幻电影中走出的角色。\n\n雨后的街道上倒映着五彩斑斓的霓虹灯光，摄影师运用了赛博朋克标志性的青橙色调，让整个画面充满了未来感和科技感。大面积的反光与高对比度的光影处理，让每一张照片都充满了视觉震撼。\n\n这是一次大胆的风格尝试，也是对时尚边界的又一次突破。未来的时尚，或许就藏在这些充满想象力的画面之中。",
    date: "2026-07-31",
    views: 17890,
    likes: 3890,
    tags: ["时尚", "赛博朋克", "未来感", "科技"],
  },
  {
    id: 10,
    title: "夏日泳池派对｜阳光下的活力性感",
    slug: "summer-pool-party-photoshoot",
    category: "xinggan",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Asian%20woman%20in%20stylish%20one%20piece%20swimsuit%20sitting%20elegantly%20by%20infinity%20pool%20edge%20overlooking%20ocean%20at%20sunset%2C%20golden%20warm%20sunlight%2C%20sparkling%20water%20reflections%2C%20healthy%20glowing%20skin%2C%20summer%20vibes%20luxury%20resort%20photography%2C%20tasteful%20beachwear%20editorial%2C%20fresh%20and%20energetic%20composition&width=1200&height=800&seq=article-10&orientation=landscape",
    excerpt: "夕阳西下，无边泳池的边缘连接着海天一色的壮丽景色。一位身材曼妙的女神在金色的阳光下，展现了夏日最具活力的一面。",
    content: "海岛的夏天永远不会结束。在泰国普吉岛的一处悬崖别墅，我们完成了这组充满夏日气息的泳池写真。\n\n无边泳池的边缘仿佛与安达曼海融为一体，夕阳将天空染成了橙金色。模特一身简约的连体泳衣，健康的肌肤在金色阳光下泛着迷人的光泽。\n\n摄影师巧妙地利用了水面的反射光，让人物的面庞被柔和的光线包裹。时而模特在水中轻盈游动，时而坐在池边远眺海平线，每一个瞬间都充满了度假的惬意与自由。\n\n这组作品捕捉了夏天最美好的样子——阳光、碧水、海风，以及那份无拘无束的自在。生活的美好，不过如此。",
    date: "2026-07-30",
    views: 21340,
    likes: 5340,
    tags: ["性感", "泳池", "夏日", "海岛"],
  },
  {
    id: 11,
    title: "敦煌飞天壁画｜西域古风的绝美演绎",
    slug: "dunhuang-flying-apsara-photoshoot",
    category: "gufeng",
    image: "https://readdy.ai/api/search-image?query=Ethereal%20Asian%20woman%20in%20flowing%20colorful%20silk%20ribbons%20and%20ancient%20Chinese%20dance%20costume%20inspired%20by%20Dunhuang%20murals%20posing%20in%20desert%20at%20golden%20sunset%20with%20sand%20dunes%2C%20dramatic%20wind%20swept%20fabric%2C%20mystical%20ancient%20silk%20road%20aesthetic%2C%20warm%20earth%20tones%20and%20vibrant%20fabric%20colors%2C%20fine%20art%20dance%20photography%2C%20heavenly%20and%20transcendent%20atmosphere&width=1200&height=800&seq=article-11&orientation=landscape",
    excerpt: "金色沙丘之上，一位舞者身着敦煌壁画中飞天的霓裳，在落日余晖中翩翩起舞。这是一次跨越千年的文化对话，一场西域古风的绝美演绎。",
    content: "在大西北的广袤沙漠中，夕阳将沙丘染成金色，我们完成了一次致敬敦煌文化的艺术创作。\n\n模特的服装灵感来源于敦煌莫高窟壁画中的飞天形象，五彩的丝绸飘带在沙漠的风中猎猎飘扬。华丽的金色头饰和繁复的璎珞项链，每一个细节都经过了精心的考据与设计。\n\n摄影师选择在日落前的黄金时刻进行拍摄。夕阳的暖光与五彩的衣袂交相辉映，风吹起的沙粒在逆光中形成了金色的光雾，仿佛真的来到了千年前的西域古国。\n\n这组作品不仅是一次摄影创作，更是对中华灿烂文化的致敬与传承。千年的美，从未褪色。",
    date: "2026-07-29",
    views: 13450,
    likes: 3120,
    tags: ["古风", "敦煌", "西域", "飞天"],
  },
  {
    id: 12,
    title: "京都秋日物语｜红叶下的日系温婉",
    slug: "kyoto-autumn-tale-photoshoot",
    category: "rixi",
    image: "https://readdy.ai/api/search-image?query=Gentle%20Asian%20woman%20in%20elegant%20kimono%20with%20autumn%20leaf%20pattern%20walking%20through%20historic%20Kyoto%20temple%20path%20lined%20with%20brilliant%20red%20maple%20trees%2C%20soft%20afternoon%20sunlight%2C%20traditional%20Japanese%20aesthetic%2C%20serene%20and%20peaceful%20atmosphere%2C%20travel%20photography%20style%2C%20warm%20autumn%20color%20palette%2C%20cultural%20elegance%20and%20natural%20beauty&width=1200&height=800&seq=article-12&orientation=landscape",
    excerpt: "深秋的京都，红叶如火焰般绚烂。一位身穿和服的温婉女子漫步在古寺的石径上，每一步都踏出了日式美学中特有的侘寂与幽玄。",
    content: "京都的红叶季，是一年中最美的时节。我们专程飞往日本京都，在有着百年历史的寺庙庭院中完成了这组充满秋意的日系写真。\n\n模特身着一件枫叶图案的访问和服，腰间的织锦带结精致而优雅。她缓缓走在铺满红叶的石径上，偶尔停下脚步，仰望头顶如火般绚烂的枫叶。每一个动作都那么从容、优雅、恰到好处。\n\n摄影师大量运用了逆光和侧光，让红叶的色彩饱和度达到极致，同时保持了人物肤色的柔和自然。画面中的空间留白和不对称构图，体现出了浓厚的日式美学精神。\n\n京都的秋，是一首写不完的诗。而这组作品，就是我们献给京都之秋的一封情书。",
    date: "2026-07-28",
    views: 16540,
    likes: 3870,
    tags: ["日系", "京都", "和服", "红叶"],
  },
];

export const featuredArticles = [1, 2, 3, 9, 11, 12];

export const faqItems = [
  {
    question: "这个网站的图片来自哪里？",
    answer: "本网站的所有图片均由专业摄影师团队拍摄创作，部分图片来自国内外知名图库授权使用。我们严格尊重版权，所有展示内容均获得合法授权。",
  },
  {
    question: "网站上的图片可以下载使用吗？",
    answer: "本网站展示的图片仅供在线欣赏。如需下载或商业使用，请通过联系方式与我们取得联系，获取正式授权。未经授权的下载和使用可能涉及版权侵权。",
  },
  {
    question: "网站多久更新一次内容？",
    answer: "我们保持每日更新的频率，每天都会有新的美女写真作品上线。同时，每周会推出精选合集和主题策划，力求为用户带来持续新鲜的视觉体验。",
  },
  {
    question: "如何成为网站的签约模特？",
    answer: "欢迎有模特梦想的你加入我们！请通过关于我们页面的联系表单提交你的个人资料和作品集，我们的经纪团队会在一周内进行审核并回复。",
  },
  {
    question: "网站支持哪些设备浏览？",
    answer: "本网站采用响应式设计，完美支持电脑、平板、手机等各类设备浏览。无论在哪种设备上，您都能获得最佳的图片欣赏体验。",
  },
];

export const aboutInfo = {
  brandName: "美女图精选合集",
  brandIntro:
    "美女图精选合集成立于2020年，是国内领先的高清美女写真图片分享平台。我们致力于汇聚国内外最优质的美女摄影作品，为用户提供高品质的视觉欣赏体验。经过多年的发展，我们已经积累了超过5000组精品写真作品，涵盖清纯、气质、时尚、性感、古风、日系等多个风格分类，累计服务用户超过百万。",
  mission:
    "我们相信，每一位女性都有她独特的美。我们的使命是用镜头捕捉这些美的瞬间，让更多人能够发现美、欣赏美、感受美。我们不仅是一个图片分享平台，更是一个传播美的力量的社区。",
  stats: [
    { label: "精品写真", value: "5000+" },
    { label: "签约模特", value: "200+" },
    { label: "合作摄影师", value: "80+" },
    { label: "累计用户", value: "100万+" },
  ],
  contact: {
    email: "contact@meinvtu.com",
    wechat: "meinvtu-official",
    weibo: "@美女图精选合集",
    address: "浙江省杭州市西湖区文三路478号华星时代广场A座15层",
    phone: "0571-8888-6666",
  },
};